/* eslint-disable no-unused-vars */
import React, { useContext, useState, useRef } from "react";
import { withRouter, Link } from "react-router-dom";
import _ from "lodash";
import { connect } from "react-redux";
import { ModalContext } from "App";
import Modal from "modules/common/components/Modal";
import PropTypes from "prop-types";
import * as actions from "../action";
import * as c from "../constant";
import UpdateMobileNumberModal from "./UpdateMobileNumberModal";

const form = {
  pin: "",
};

function PinModalContainer({
  mobileNo,
  updateOtp,
  resendOtpMobile,
  isLoading,
  showTransaction,
  getTransactionList,
  taxpayerId,
  taxpayers
}) {
  const replaced =
    mobileNo.slice(0, 2) + mobileNo.slice(2).replace(/.(?=...)/g, "*");

  const [formData, setFormData] = useState(form);

  const handleOnChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const setModal = useContext(ModalContext);

  const handleResendOtp = e => {
    e.preventDefault();
    resendOtpMobile(taxpayerId);
  };

  const handleOnSubmit = e => {
    e.preventDefault();
    const args = {
      pin: formData.pin
    }

    updateOtp(taxpayerId, args, (res) => {
        setModal({ isOpen: false });
        getTransactionList();
        showTransaction(res.res.data.id);
      }
    );
  };

  const handleGoBack = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateMobileNumberModal
          taxpayers={taxpayers}
          taxpayerId={taxpayerId}
        />
      ),
      title: 'Update Mobile Number',
      modalSize: 'modal-md',
    });
  };

  return (
    <Modal.Body className="p-0">
      <div className="forgot-container">
        <button onClick={handleGoBack} type="button" className="btn btn-link">
          <i className="fas fa-chevron-left back-login" />
        </button>
        <div className="container-fluid">
          <div className="row">
            <div className="form-section col-12 d-flex align-items-center">
              <div className="form-content w-100">
                <h2 className="font-weight-bold mb-3">
                  SMS Verification
                </h2>
                <p>
                  A verification sms has been sent to +{replaced}.
                </p>
                <p>
                  Enter OTP to update the mobile number.
                </p>
                <form onSubmit={handleOnSubmit}>
                  <div id="divOuter" className="form-group form-row">
                    <div id="divInner">
                      <input
                        id="partitioned"
                        name="pin"
                        autoFocus
                        autoComplete="off"
                        required
                        className="otp-value"
                        type="tel"
                        maxLength="6"
                        onChange={handleOnChange}
                      />
                      <div className="profile-under" />
                    </div>
                  </div>
                  <Link
                    to="/"
                    onClick={handleResendOtp}
                    className="mt-3 d-block text-xs"
                  >
                    Didn`t Receive OTP? <strong>Resend.</strong>
                  </Link>
                  <button
                    type="submit"
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary  w-100 mt-4 cms-bg-color-primary"
                    disabled={isLoading}
                  >
                    {isLoading && <i className="fa fa-spin fa-spinner" />}{" "}
                    Validate OTP
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal.Body>
  );
}

PinModalContainer.propTypes = {
  mobileNo: PropTypes.string.isRequired,
  updateOtp: PropTypes.instanceOf(Function).isRequired,
  resendOtpMobile: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
  taxpayerId: PropTypes.string.isRequired,
  taxpayers: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: _.get(api, "loading", []).indexOf(c.UPDATE_OTP) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(PinModalContainer);
